// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__25G1-","content":"styles_content__1-hMC","textInputWidthDefault":"styles_textInputWidthDefault__WgreQ","flexButton":"styles_flexButton__rTVPu"};